import { React } from "react";

import RevisionsButton from "../buttons/RevisionsButton";
import { Badge } from "shards-react";
import { NavLink } from "react-router-dom";
import default_image from "../../../images/eitri_logo_placeholder.png";

const showBadgeStatus = ({ data }) => {
    const { status } = data;
    const badgeConfig = {};

    if (status === "ACTIVE") {
        badgeConfig.theme = "success";
        badgeConfig.text = "ativo";
    } else {
        badgeConfig.theme = "danger";
        badgeConfig.text = "inativo";
    }

    return (
        <Badge pill theme={badgeConfig.theme}>
            {badgeConfig.text}
        </Badge>
    );
};

const getInvisibeFieldsToFilter = () => {
    const fields = ["title", "slug", "featureToggleKey", "walletToken"];
    return fields.map(field => ({ field, hide: true }));
};

export const getGridOptions = () => {
    return [
        ...getInvisibeFieldsToFilter(),
        {
            headerName: "Nome",
            field: "name",
            sortable: true,
            filter: true,
            flex: 3,
            cellRendererFramework: params => {
                const { icon, slug, name } = params.data;
                const iconToShow = icon ? icon : default_image;
                return (
                    <NavLink
                        to={`/applications/${slug}/configurations`}
                        state={{
                            dataProps: {
                                miniApp: params.data
                            }
                        }}
                        style={{ width: "100%" }}
                    >
                        <img
                            src={iconToShow}
                            style={{ width: 32, marginRight: 23 }}
                        />
                        <span className={`cypress--miniapp`}>{name}</span>
                    </NavLink>
                );
            }
        },
        {
            headerName: "Status",
            filter: "statusFilter",
            field: "status",
            sortable: true,
            flex: 1,
            cellRendererFramework: params => showBadgeStatus(params)
        },
        {
            headerName: "Versões",
            field: "revisions",
            sortable: false,
            filter: false,
            flex: 1,
            cellRendererFramework: params => (
                <RevisionsButton miniApp={params.data} />
            )
        }
    ];
};
